import { Tooltip } from '@material-ui/core';
import CSS from 'csstype';
import React from 'react';

import { ELogicalOperator } from '~/src/dash/apiV2/targeting/targetingPresets';
import { Col, Cols, spacing, Text } from '~/src/dash/publicaUI';
import { publicaColors } from '~/src/dash/utils/colors';

const logicButtonStyle = {
  border: `1px solid ${publicaColors.veryDarkGray}`,
  borderRadius: '4px',
  padding: `1px ${spacing.extraSmall} 0`,
  textAlign: 'center',
  width: '36px',
} as CSS.Properties;

const AndButton = () => {
  return (
    <Text
      extraSmall
      bold
      style={{
        ...logicButtonStyle,
        backgroundColor: publicaColors.lavender,
      }}
    >
      AND
    </Text>
  );
};

const OrButton = () => {
  return (
    <Text
      extraSmall
      bold
      style={{
        ...logicButtonStyle,
        backgroundColor: publicaColors.veryLightYellow,
      }}
    >
      OR
    </Text>
  );
};

interface IProps {
  operator: ELogicalOperator;
  handleToggleOperator: () => void;
  tooltip?: string;
  label?: string;
}

export const LogicToggle = ({
  operator,
  handleToggleOperator,
  tooltip = '',
  label = '',
}: IProps) => {
  const isOperatorAnd = operator === ELogicalOperator.AND;

  return (
    <Cols gap={spacing.small} style={{ alignItems: 'center' }}>
      {label && (
        <Col>
          <Text small disableSelect>
            {label}
          </Text>
        </Col>
      )}
      <Col>
        <Tooltip title={tooltip} placement='top'>
          <div
            style={{
              height: '32px',
              display: 'flex',
              alignItems: 'center',
              cursor: 'pointer',
            }}
            onClick={handleToggleOperator}
          >
            {isOperatorAnd ? <AndButton /> : <OrButton />}
          </div>
        </Tooltip>
      </Col>
    </Cols>
  );
};
